import { gql } from "@apollo/client";

export const GET_TIPPERS_WITH_CHIPS = gql`
  query GetTippersWithChips($username: String, $minCurrentTips: Int) {
    getTippersWithChips(username: $username, minCurrentTips: $minCurrentTips) {
      tippers {
        id
        broadcaster
        username
        chips
        currentTips
        inFanclub
        isFollower
        isMod
      }
      totalChips
    }
  }
`;

export const UPDATE_TIPPER_CHIPS = gql`
  mutation UpdateTipperChips($input: UpdateTipperChipsInput!) {
    updateTipperChips(input: $input) {
      id
      username
      chips
      currentTips
    }
  }
`;

export const CREATE_TIPPER = gql`
  mutation CreateTipper($input: CreateTipperInput!) {
    createTipper(input: $input) {
      id
      username
      chips
      currentTips
      broadcaster
    }
  }
`;
